// Fonction utilitaire réutilisable pour importer automatiquement tous les fichiers de traduction
export function importAllTranslations(requireContext) {
  let translations = {};
  requireContext.keys().forEach((item) => {
    const module = requireContext(item);
    const key = item.replace('./', '').replace('.js', '');
    translations[key] = module.default || module;
  });
  return translations;
}
